import { render, staticRenderFns } from "./detailListing.vue?vue&type=template&id=2116088c&scoped=true"
import script from "./detailListing.vue?vue&type=script&lang=js"
export * from "./detailListing.vue?vue&type=script&lang=js"
import style0 from "./detailListing.vue?vue&type=style&index=0&id=2116088c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2116088c",
  null
  
)

export default component.exports